webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(10);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(73);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _bourgeon = __webpack_require__(12);
	
	var _bourgeon2 = _interopRequireDefault(_bourgeon);
	
	var _App = __webpack_require__(57);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Header = __webpack_require__(64);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(63);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_bourgeon2.default, {
	  locales: ['fr', 'en']
	});
	
	_vue2.default.use(_vueResource2.default);
	
	new _vue2.default({
	  render: function render(h) {
	    return h(_Header2.default);
	  }
	}).$mount('header');
	
	new _vue2.default({
	  render: function render(h) {
	    return h(_Footer2.default);
	  }
	}).$mount('footer');
	
	new _vue2.default({
	  render: function render(h) {
	    return h(_App2.default);
	  }
	}).$mount('#app');

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var marked = __webpack_require__(52);
	
	module.exports = {
	  capitalize: function capitalize(value, key) {
	    if (!value) return '';
	    value = value.toString();
	    return value.charAt(0).toUpperCase() + value.slice(1);
	  },
	  compiledMarkdown: function compiledMarkdown(input) {
	    return marked(input, { sanitize: true });
	  },
	  recipeDescription: function recipeDescription(input) {
	    var s = input.split(' ');
	    var l = 100;
	    var r = '';
	    for (var i = 0; i < s.length; i++) {
	      if (r.length < l) {
	        r += ' ' + s[i];
	      }
	    }
	    r += '...';
	    return r;
	  },
	  formatUrl: function formatUrl(input) {
	    return 'https://api.tradfood.fr/' + input;
	  }
	};

/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(24);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(25);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Parallax = function () {
	  function Parallax() {
	    (0, _classCallCheck3.default)(this, Parallax);
	  }
	
	  (0, _createClass3.default)(Parallax, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.els = [];
	      this.els = document.querySelectorAll('[data-parallax]');
	      this.scrollHandler();
	      document.addEventListener('scroll', function (evt) {
	        return _this.scrollHandler(evt);
	      });
	      window.addEventListener('resize', function (evt) {
	        return _this.scrollHandler(evt);
	      });
	    }
	  }, {
	    key: 'scrollHandler',
	    value: function scrollHandler() {
	      for (var i = 0; i < this.els.length; i++) {
	        var el = this.els[i];
	        var factor = parseInt(el.getAttribute('data-parallax')) || 1;
	
	        var elRect = el.getBoundingClientRect();
	
	        var percent = Math.round((elRect.top + el.offsetHeight) / (window.innerHeight + el.offsetHeight) * 100);
	        percent = Math.max(0, Math.min(100, percent));
	
	        var translation = Math.round(factor * (percent - 50));
	
	        el.style.transform = 'translateY(' + translation + 'px)';
	      }
	    }
	  }]);
	  return Parallax;
	}();
	
	exports.default = Parallax;

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports) {

	module.exports = {"mealType":[{"text":"Tout","value":"all"},{"text":"Entrée","value":"starter"},{"text":"Plat","value":"main course"},{"text":"Dessert","value":"dessert"}],"difficulty":[{"text":"Tout","value":"all"},{"text":"Facile","value":"1"},{"text":"Moyen","value":"2"},{"text":"Difficile","value":"3"}]}

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(10);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueI18n = __webpack_require__(56);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  install: function install(Vue, options) {
	    var locales = options;
	
	    Vue.use(_vueI18n2.default);
	
	    Vue.config.fallbackLang = locales[0];
	    Vue.config.lang = options.indexOf(navigator.language > -1) ? navigator.language : Vue.config.fallbackLang;
	
	    options.forEach(function (lang) {
	      Vue.locale(lang, __webpack_require__(75)("./" + lang + '.yml'));
	    });
	
	    Vue.mixin({
	      computed: {
	        lang: {
	          get: function get() {
	            return Vue.config.lang;
	          },
	          set: function set(lang) {
	            Vue.config.lang = lang;
	          }
	        },
	        locales: {
	          get: function get() {
	            return locales;
	          }
	        }
	      },
	      methods: {
	        setLang: function setLang(lang) {
	          this.lang = lang;
	        },
	        isLang: function isLang(lang) {
	          return this.lang === lang;
	        }
	      }
	    });
	  }
	};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _router = __webpack_require__(13);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _i18n = __webpack_require__(11);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  install: function install(Vue, options) {
	    Vue.use(_router2.default);
	    Vue.use(_i18n2.default, options.locales);
	  }
	};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueRouter = __webpack_require__(74);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(14);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _meta = __webpack_require__(51);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  router: null,
	  install: function install(Vue) {
	    var router = new _vueRouter2.default({
	      routes: _routes2.default,
	      mode: 'history'
	    });
	
	    Vue.mixin({
	      beforeCreate: function beforeCreate() {
	        if (this.$root === this) {
	          this.$options.router = router;
	        }
	      }
	    });
	
	    router.beforeEach(function (to, from, next) {
	      if (to.meta.title == null || to.meta.title.lenght <= 0) {
	        document.title = _meta2.default.completeTitle;
	      } else {
	        document.title = to.meta.title + ' | ' + _meta2.default.title;
	      }
	      next();
	    });
	
	    Vue.use(_vueRouter2.default);
	  }
	};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Welcome = __webpack_require__(62);
	
	var _Welcome2 = _interopRequireDefault(_Welcome);
	
	var _NotFound = __webpack_require__(60);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _About = __webpack_require__(58);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _City = __webpack_require__(59);
	
	var _City2 = _interopRequireDefault(_City);
	
	var _Recipe = __webpack_require__(61);
	
	var _Recipe2 = _interopRequireDefault(_Recipe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	  path: '/',
	  component: _Welcome2.default,
	  name: 'home'
	}, {
	  path: '*',
	  component: _NotFound2.default,
	  name: '404'
	}, {
	  path: '/a-propos',
	  component: _About2.default,
	  name: 'about',
	  meta: {
	    title: 'A Propos'
	  }
	}, {
	  path: '/:city',
	  component: _City2.default,
	  name: 'city',
	  meta: {
	    title: 'Ville'
	  }
	}, {
	  path: '/:city/:recipe',
	  component: _Recipe2.default,
	  name: 'recipe',
	  meta: {
	    title: 'Recette'
	  }
	}];

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Parallax = __webpack_require__(3);
	
	var _Parallax2 = _interopRequireDefault(_Parallax);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  filters: __webpack_require__(1),
	  data: function data() {
	    return {
	      team: [{ name: 'Joshua', slug: 'joshua', link: 'https://joshuarichard.fr/' }, { name: 'Bastien', slug: 'bastien', link: 'https://bastienrobert.fr' }, { name: 'Roxane', slug: 'roxane', link: 'https://roxanezebina.com' }, { name: 'Clément', slug: 'clement', link: 'https://www.linkedin.com/in/cl%C3%A9ment-renaud-b4a5ba162/' }, { name: 'Lilou', slug: 'lilou', link: 'https://drive.google.com/file/d/16iYHuIFXYsAmBy1C65yBOqkRyln--BLd/view' }, { name: 'Milène', slug: 'milene', link: 'http://milene-jahanpour.fr/' }, { name: 'Nino', slug: 'nino', link: 'https://nino.treyssatvincent.fr/' }, { name: '' }]
	    };
	  },
	  mounted: function mounted() {
	    var parallax = new _Parallax2.default();
	    parallax.init();
	  }
	};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Parallax = __webpack_require__(3);
	
	var _Parallax2 = _interopRequireDefault(_Parallax);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  filters: __webpack_require__(1),
	  data: function data() {
	    return {
	      city: [],
	      recipes: '',
	      filtersData: {
	        mealType: this.$route.params.mealType || 'all',
	        difficulty: this.$route.params.difficulty || 'all'
	      },
	      filtersOptions: __webpack_require__(9)
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var url = 'https://api.tradfood.fr/' + this.$route.params.city + '.json';
	    this.$http.get(url).then(function (response) {
	      _this.city = response.body;
	      _this.recipes = response.body.recipes;
	      _this.sort();
	      _this.meta();
	    }, function (response) {
	      _this.$router.push('/');
	    });
	    var parallax = new _Parallax2.default();
	    parallax.init();
	  },
	
	  methods: {
	    sort: function sort() {
	      var _this2 = this;
	
	      var filteredRecipes = [];
	      this.city.recipes.map(function (k, v) {
	        _this2.filter(k) ? filteredRecipes.push(k) : null;
	      });
	      this.recipes = filteredRecipes;
	    },
	    filter: function filter(v) {
	      if ((v.difficulty === parseInt(this.filtersData.difficulty) || this.filtersData.difficulty === 'all') && (v.meal_type === this.filtersData.mealType || this.filtersData.mealType === 'all')) {
	        return true;
	      }
	      return false;
	    },
	    meta: function meta() {
	      document.title = this.city.name + ' | TradFood';
	      document.querySelector('meta[name="description"]').setAttribute('content', this.$options.filters.recipeDescription(this.city.description) + ' A découvrir sur TradFood !');
	    }
	  }
	};

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  filters: __webpack_require__(1),
	  data: function data() {
	    return {
	      recipe: []
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var url = 'https://api.tradfood.fr/' + this.$route.params.city + '/' + this.$route.params.recipe + '.json';
	    this.$http.get(url).then(function (response) {
	      _this.recipe = response.body;
	      _this.meta();
	    }, function (response) {
	      console.log(response);
	    });
	  },
	
	  methods: {
	    meta: function meta() {
	      document.title = this.recipe.name + ' | TradFood';
	      document.querySelector('meta[name="description"]').setAttribute('content', this.$options.filters.recipeDescription(this.recipe.description) + ' A découvrir sur TradFood !');
	    }
	  }
	};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Parallax = __webpack_require__(3);
	
	var _Parallax2 = _interopRequireDefault(_Parallax);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  filters: __webpack_require__(1),
	  data: function data() {
	    return {
	      city: [],
	      highlight: [],
	      recipes: [],
	      trends: null,
	      filtersData: {
	        mealType: 'all',
	        difficulty: 'all'
	      },
	      filtersOptions: __webpack_require__(9)
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var url = 'https://api.tradfood.fr/bordeaux.json';
	    this.$http.get(url).then(function (response) {
	      _this.city = response.body;
	      _this.city.recipes.map(function (k, v) {
	        k.highlight ? _this.highlight.push(k) : null;
	      });
	      _this.highlight = _this.shuffle(_this.highlight, 2);
	      _this.recipes = _this.shuffle(_this.city.recipes, 6);
	    }, function (response) {
	      console.log(response);
	    });
	    var parallax = new _Parallax2.default();
	    parallax.init();
	  },
	
	  methods: {
	    shuffle: function shuffle(arr, x) {
	      var shuffled = arr.sort(function () {
	        return 0.5 - Math.random();
	      });
	      return shuffled.slice(0, x);
	    },
	    redirect: function redirect() {
	      this.$router.push({
	        name: 'city',
	        params: {
	          city: this.city.url,
	          mealType: this.filtersData.mealType,
	          difficulty: this.filtersData.difficulty
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      menu: null
	    };
	  },
	  mounted: function mounted() {
	    this.menu = document.getElementById('menu-toggle');
	  },
	
	  methods: {
	    menuToggle: function menuToggle() {
	      var nav = document.getElementsByTagName('nav')[0];
	      this.menu.classList.toggle('cross');
	      nav.classList.toggle('visible');
	      document.body.classList.toggle('overflow');
	    }
	  },
	  watch: {
	    $route: function $route(to, from) {
	      if (this.menu.classList.contains('cross')) {
	        this.menuToggle();
	      }
	    }
	  }
	};

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports) {

	module.exports = {"messages":{"404":"404 not found!","welcome":"Welcome to your Bourgeon app!","hello":"Hello {name}!"},"buttons":{"home":"Home","hello":"Hello"},"locales":{"fr":"French","en":"English"},"city":{"difficulty":"Difficulty","mealType":"Meal Type"},"recipe":{"filters":{"difficulty":{"1":"Easy","2":"Quite Difficult","3":"Difficult"},"mealType":{"starter":"Starter","main-course":"Main course","dessert":"Dessert"},"season":{"summer":"Summer","autumn":"Autumn","spring":"Spring","winter":"Winter"}}},"about":{"description":["Trad’Food est une plateforme en ligne ouverte à tous. Elle permet à chacun, qu’il soit local ou touriste, de découvrir ou de redécouvrir, les recettes emblématiques du terroir français, mais aussi les lieux où les déguster.","Avec une première version axée sur les plats traditionnels de Bordeaux et ses alentours, TradFood a pour but final de proposer à ses utilisateurs un contenu plus large recensant les richesses gastronomiques des différentes régions françaises.","Grâce à la liste de restaurants présents sur Trad’ Food, chacun pourra aisément déguster chacuns des plats traditionnels proposés, mais aussi les préparer grâce au large panel de recettes et de conseils accessibles sur le site.","Ce projet a été créé par une équipe de 6 étudiants en MMI à l’IUT Bordeaux Montaigne, dans le cadre d’un projet d’intégration web sur l’année scolaire 2016-2017. Ce dernier est basé sur le thème “manger sur Bordeaux”."]}}

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	module.exports = {"messages":{"404":"Erreur 404 !","welcome":"Bienvenue sur votre application Bourgeon !","hello":"Bonjour {name} !"},"buttons":{"home":"Accueil","hello":"Bonjour"},"locales":{"fr":"Français","en":"Anglais"},"city":{"difficulty":"Difficulté","mealType":"Type"},"recipe":{"filters":{"difficulty":{"1":"Facile","2":"Moyen","3":"Difficile"},"mealType":{"starter":"Entrée","main-course":"Plat principal","dessert":"Dessert"},"season":{"summer":"Été","automn":"Automne","spring":"Printemps","winter":"Hiver"}}},"about":{"description":["Trad’Food est une plateforme en ligne ouverte à tous. <br> Elle permet à chacun, qu’il soit local ou touriste, de découvrir ou de redécouvrir, les recettes emblématiques du terroir français, mais aussi les lieux où les déguster.","Avec une première version axée sur les plats traditionnels de Bordeaux et ses alentours, TradFood a pour but final de proposer à ses utilisateurs un contenu plus large recensant les richesses gastronomiques des différentes régions françaises.","Grâce à la liste de restaurants présents sur Trad’ Food, chacun pourra aisément déguster chacuns des plats traditionnels proposés, mais aussi les préparer grâce au large panel de recettes et de conseils accessibles sur le site.","Ce projet a été créé par une équipe de 6 étudiants en MMI à l’IUT Bordeaux Montaigne, dans le cadre d’un projet d’intégration web sur l’année scolaire 2016-2017. Ce dernier est basé sur le thème “manger sur Bordeaux”."]}}

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	module.exports = {"title":"TradFood","completeTitle":"Trad'Food - Manger et cuisiner traditionnel à Bordeaux"}

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(44)
	
	/* script */
	__vue_exports__ = __webpack_require__(15)
	
	/* template */
	var __vue_template__ = __webpack_require__(70)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(46)
	
	/* script */
	__vue_exports__ = __webpack_require__(16)
	
	/* template */
	var __vue_template__ = __webpack_require__(72)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c3820e84"
	
	module.exports = __vue_exports__


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(40)
	
	/* script */
	__vue_exports__ = __webpack_require__(17)
	
	/* template */
	var __vue_template__ = __webpack_require__(66)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(41)
	
	/* script */
	__vue_exports__ = __webpack_require__(18)
	
	/* template */
	var __vue_template__ = __webpack_require__(67)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(43)
	
	/* script */
	__vue_exports__ = __webpack_require__(19)
	
	/* template */
	var __vue_template__ = __webpack_require__(69)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(39)
	
	/* script */
	__vue_exports__ = __webpack_require__(20)
	
	/* template */
	var __vue_template__ = __webpack_require__(65)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(45)
	
	/* script */
	__vue_exports__ = __webpack_require__(21)
	
	/* template */
	var __vue_template__ = __webpack_require__(71)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a992702e"
	
	module.exports = __vue_exports__


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(42)
	
	/* script */
	__vue_exports__ = __webpack_require__(22)
	
	/* template */
	var __vue_template__ = __webpack_require__(68)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-672da84a"
	
	module.exports = __vue_exports__


/***/ }),
/* 65 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "homepage"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "search"
	    }
	  }, [_c('h2', [_vm._v("Rechercher une recette")]), _vm._v(" "), _c('form', {
	    attrs: {
	      "id": "sort"
	    }
	  }, [_c('div', {
	    staticClass: "radio-group"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('city.mealType')))]), _vm._v(" "), _vm._l((_vm.filtersOptions.mealType), function(option) {
	    return _c('span', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.filtersData.mealType),
	        expression: "filtersData.mealType"
	      }],
	      attrs: {
	        "type": "radio",
	        "name": "mealType",
	        "id": 'mealType-' + option.value
	      },
	      domProps: {
	        "value": option.value,
	        "checked": _vm._q(_vm.filtersData.mealType, option.value)
	      },
	      on: {
	        "change": function($event) {
	          _vm.$set(_vm.filtersData, "mealType", option.value)
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": 'mealType-' + option.value
	      }
	    }, [_vm._v(_vm._s(option.text))])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "radio-group"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('city.difficulty')))]), _vm._v(" "), _vm._l((_vm.filtersOptions.difficulty), function(option) {
	    return _c('span', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.filtersData.difficulty),
	        expression: "filtersData.difficulty"
	      }],
	      attrs: {
	        "type": "radio",
	        "name": "difficulty",
	        "id": 'difficulty-' + option.value
	      },
	      domProps: {
	        "value": option.value,
	        "checked": _vm._q(_vm.filtersData.difficulty, option.value)
	      },
	      on: {
	        "change": function($event) {
	          _vm.$set(_vm.filtersData, "difficulty", option.value)
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": 'difficulty-' + option.value
	      }
	    }, [_vm._v(_vm._s(option.text))])])
	  })], 2), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "submit",
	      "value": "Envoyer"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.redirect($event)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "trends"
	    }
	  }, [_c('h2', [_vm._v("Tendances")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "recipes"
	  }, _vm._l((_vm.highlight), function(recipe) {
	    return _c('div', {
	      staticClass: "recipe"
	    }, [_c('img', {
	      attrs: {
	        "src": _vm.$options.filters.formatUrl(recipe.image.url),
	        "alt": recipe.name
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "description"
	    }, [_c('h3', [_vm._v(_vm._s(recipe.name.split(' ')[0]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("recipeDescription")(recipe.description)))]), _vm._v(" "), _c('router-link', {
	      staticClass: "button",
	      attrs: {
	        "to": {
	          name: 'recipe',
	          params: {
	            city: _vm.city.url,
	            recipe: recipe.url
	          }
	        }
	      }
	    }, [_vm._v("\n            en savoir +\n          ")])], 1)])
	  }))]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "display"
	    }
	  }, [_c('h2', [_vm._v("Recettes à l'affiche")]), _vm._v(" "), _c('ul', {
	    staticClass: "recipes"
	  }, _vm._l((_vm.recipes), function(recipe) {
	    return _c('li', {
	      staticClass: "recipe"
	    }, [_c('div', {
	      staticClass: "image-container"
	    }, [_c('img', {
	      attrs: {
	        "src": _vm.$options.filters.formatUrl(recipe.image.url),
	        "alt": recipe.name
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "description"
	    }, [_c('h3', [_vm._v(_vm._s(recipe.name.split(' ')[0]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("recipeDescription")(recipe.description)))]), _vm._v(" "), _c('router-link', {
	      staticClass: "button",
	      attrs: {
	        "to": {
	          name: 'recipe',
	          params: {
	            city: _vm.city.url,
	            recipe: recipe.url
	          }
	        }
	      }
	    }, [_vm._v("\n            en savoir +\n          ")])], 1)])
	  }))]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "bread",
	      "data-parallax": "2"
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "plate"
	    }
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "hola"
	    }
	  }, [_c('div', {
	    staticClass: "main-image"
	  }), _vm._v(" "), _c('div', [_c('h1', [_vm._v("Bienvenue sur TradFood !")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n          Trad’ Food est une plateforme en ligne ouverte à tous.\n          Elle vous permet, que vous soyez locaux ou touristes, de découvrir ou de redécouvrir, les recettes les plus emblématiques du terroir bordelais.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Avec un panel de recettes triées par difficultés, saisons, et types de plats, le site vous propose de réaliser par vous même les recettes bordelaises qui font la richesse gastronomique de la région bordelaise.\n        ")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("Découvrez nos dernières recettes tendances"), _c('br'), _vm._v(" et savourez-les en apprenant à les cuisiner vous-même !")])
	}]}

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    attrs: {
	      "id": "sort"
	    }
	  }, [_c('div', {
	    staticClass: "radio-group"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('city.mealType')))]), _vm._v(" "), _vm._l((_vm.filtersOptions.mealType), function(option) {
	    return _c('span', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.filtersData.mealType),
	        expression: "filtersData.mealType"
	      }],
	      attrs: {
	        "type": "radio",
	        "name": "mealType",
	        "id": 'mealType-' + option.value
	      },
	      domProps: {
	        "value": option.value,
	        "checked": _vm._q(_vm.filtersData.mealType, option.value)
	      },
	      on: {
	        "change": [function($event) {
	          _vm.$set(_vm.filtersData, "mealType", option.value)
	        }, _vm.sort]
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": 'mealType-' + option.value
	      }
	    }, [_vm._v(_vm._s(option.text))])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "radio-group"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('city.mealType')))]), _vm._v(" "), _vm._l((_vm.filtersOptions.difficulty), function(option) {
	    return _c('span', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.filtersData.difficulty),
	        expression: "filtersData.difficulty"
	      }],
	      attrs: {
	        "type": "radio",
	        "name": "difficulty",
	        "id": 'difficulty-' + option.value
	      },
	      domProps: {
	        "value": option.value,
	        "checked": _vm._q(_vm.filtersData.difficulty, option.value)
	      },
	      on: {
	        "change": [function($event) {
	          _vm.$set(_vm.filtersData, "difficulty", option.value)
	        }, _vm.sort]
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": 'difficulty-' + option.value
	      }
	    }, [_vm._v(_vm._s(option.text))])])
	  })], 2)]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "id": "recipes"
	    }
	  }, [_vm._l((_vm.recipes), function(recipe) {
	    return _c('li', [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'recipe',
	          params: {
	            city: _vm.city.url,
	            recipe: recipe.url
	          }
	        }
	      }
	    }, [_c('span', {
	      staticClass: "img-wrap"
	    }, [_c('img', {
	      attrs: {
	        "src": _vm.$options.filters.formatUrl(recipe.image.url),
	        "alt": recipe.name
	      }
	    })]), _vm._v(" "), _c('span', {
	      staticClass: "content"
	    }, [_c('span', {
	      staticClass: "title"
	    }, [_vm._v(_vm._s(recipe.name))]), _vm._v(" "), _c('span', {
	      staticClass: "description"
	    }, [_vm._v(_vm._s(_vm._f("recipeDescription")(recipe.description)))]), _vm._v(" "), _c('button', {
	      attrs: {
	        "type": "button",
	        "name": "button"
	      }
	    }, [_vm._v("voir la recette")])])])], 1)
	  }), _vm._v(" "), (_vm.recipes.length <= 0) ? _c('p', {
	    staticClass: "no-recipe"
	  }, [_vm._v("\n      Aucun recette ne correspond à la selection\n    ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "pie",
	      "data-parallax": "2"
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t('messages.404')))]), _vm._v(" "), _c('p', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('buttons.home')))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_c('nav', [_c('ul', [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'city',
	        params: {
	          city: 'bordeaux'
	        }
	      }
	    }
	  }, [_vm._v("Villes")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'city',
	        params: {
	          city: 'bordeaux'
	        }
	      }
	    }
	  }, [_vm._v("Recettes")])], 1), _vm._v(" "), _c('li', {
	    attrs: {
	      "id": "logo"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'home'
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/logo.svg",
	      "alt": ""
	    }
	  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'about'
	      }
	    }
	  }, [_vm._v("A propos")])], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#",
	      "id": "menu-toggle"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.menuToggle($event)
	      }
	    }
	  })])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    attrs: {
	      "href": "mailto:contact@tradfood.fr"
	    }
	  }, [_vm._v("Contact")])])
	}]}

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    attrs: {
	      "id": "recipe",
	      "itemscope": "",
	      "itemtype": "http://schema.org/Recipe"
	    }
	  }, [_c('link', {
	    attrs: {
	      "itemprop": "url",
	      "href": 'https://tradfood.fr' + this.$route.fullPath
	    }
	  }), _vm._v(" "), _c('meta', {
	    attrs: {
	      "itemprop": "mainEntityOfPage",
	      "content": "True"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "recipe-image"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.$options.filters.formatUrl(_vm.recipe.image.url),
	      "alt": _vm.recipe.name,
	      "itemprop": "image"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "recipe-details"
	  }, [_c('div', {
	    staticClass: "recipe-title",
	    attrs: {
	      "itemprop": "name"
	    }
	  }, [_c('h1', [_vm._v(_vm._s(_vm.recipe.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "recipe-description"
	  }, [_c('p', [_vm._v(_vm._s(_vm.recipe.description))])]), _vm._v(" "), _c('div', {
	    staticClass: "recipe-content"
	  }, [_c('div', {
	    staticClass: "recipe-details__informations"
	  }, [_c('h2', [_vm._v("Informations")]), _vm._v(" "), _c('ul', [_c('li', {
	    attrs: {
	      "itemprop": "recipeYield"
	    }
	  }, [_vm._v("Nombre de pièces: " + _vm._s(_vm.recipe.servings))]), _vm._v(" "), _c('li', [_c('time', {
	    attrs: {
	      "itemprop": "prepTime",
	      "datetime": 'PT' + _vm.recipe.preparation_time + 'M'
	    }
	  }, [_vm._v("\n                  Temps de préparation: " + _vm._s(_vm.recipe.preparation_time) + "\n                ")])]), _vm._v(" "), _c('li', [_c('time', {
	    attrs: {
	      "itemprop": "cookTime",
	      "datetime": 'PT' + _vm.recipe.cooking_time + 'M'
	    }
	  }, [_vm._v("\n                  Temps de cuisson: " + _vm._s(_vm.recipe.cooking_time) + "\n                ")])]), _vm._v(" "), _c('li', [_vm._v("Type de plat: " + _vm._s(_vm.$t(("recipe.filters.mealType." + (_vm.recipe.meal_type.replace(/\s+/g, '-'))))))]), _vm._v(" "), _c('li', [_vm._v("Difficulté: " + _vm._s(_vm.$t(("recipe.filters.difficulty." + (_vm.recipe.difficulty)))))]), _vm._v(" "), _c('li', [_vm._v("Saison: " + _vm._s(_vm.$t(("recipe.filters.season." + (_vm.recipe.season)))))])])]), _vm._v(" "), _c('div', {
	    staticClass: "recipe-details__ingredients"
	  }, [_c('h2', [_vm._v("Ingredients")]), _vm._v(" "), _c('div', {
	    staticClass: "content",
	    attrs: {
	      "itemprop": "ingredients"
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.$options.filters.compiledMarkdown(_vm.recipe.ingredients))
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "recipe-details__recipe"
	  }, [_c('h2', [_vm._v("Recette")]), _vm._v(" "), _c('div', {
	    staticClass: "content",
	    attrs: {
	      "itemprop": "recipeInstructions"
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.$options.filters.compiledMarkdown(_vm.recipe.recipe))
	    }
	  })])])])])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "tomatoes"
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-view')
	},staticRenderFns: []}

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (this.$route.name !== 'recipe'),
	      expression: "this.$route.name !== 'recipe'"
	    }]
	  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('h2', [_vm._v("Plus")]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'about'
	      }
	    }
	  }, [_vm._v("Notre équipe")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://github.com/orgs/tradfood/teams",
	      "target": "_blank"
	    }
	  }, [_vm._v("Qui sommes-nous ?")])], 1), _vm._v(" "), _vm._m(1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v("Abonnez-vous !")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "mc_embed_signup"
	    }
	  }, [_c('form', {
	    staticClass: "validate",
	    attrs: {
	      "action": "https://tradfood.us17.list-manage.com/subscribe/post?u=aeeb4785daf341646eb4140fa&id=bf0f9b5385",
	      "method": "post",
	      "id": "mc-embedded-subscribe-form",
	      "name": "mc-embedded-subscribe-form",
	      "target": "_blank",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "mc_embed_signup_scroll"
	    }
	  }, [_c('div', {
	    staticClass: "mc-field-group"
	  }, [_c('input', {
	    staticClass: "required email",
	    attrs: {
	      "type": "email",
	      "value": "",
	      "placeholder": "Email",
	      "name": "EMAIL",
	      "id": "mce-EMAIL"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "clear",
	    attrs: {
	      "id": "mce-responses"
	    }
	  }, [_c('div', {
	    staticClass: "response",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "id": "mce-error-response"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "response",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "id": "mce-success-response"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "position": "absolute",
	      "left": "-5000px"
	    },
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "text",
	      "name": "b_aeeb4785daf341646eb4140fa_bf0f9b5385",
	      "tabindex": "-1",
	      "value": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "clear"
	  }, [_c('input', {
	    staticClass: "button",
	    attrs: {
	      "type": "submit",
	      "value": "Envoyer",
	      "name": "subscribe",
	      "id": "mc-embedded-subscribe"
	    }
	  })])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v("Contactez-nous")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "mailto:contact@tradfood.fr"
	    }
	  }, [_vm._v("contact@tradfood.fr")]), _vm._v(" "), _c('div', {
	    staticClass: "social"
	  }, [_c('a', {
	    staticClass: "twitter",
	    attrs: {
	      "href": "https://twitter.com/tradfood",
	      "target": "_blank"
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "instagram",
	    attrs: {
	      "href": "https://www.instagram.com/tradfoodfr/",
	      "target": "_blank"
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "facebook",
	    attrs: {
	      "href": "https://www.facebook.com/tradfoodfr/",
	      "target": "_blank"
	    }
	  })])])
	}]}

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "about"
	    }
	  }, [_c('h1', [_vm._v("Qui sommes-nous ?")]), _vm._v(" "), _c('div', {
	    staticClass: "description"
	  }, _vm._l((_vm.$t('about.description')), function(p) {
	    return _c('p', {
	      domProps: {
	        "innerHTML": _vm._s(p)
	      }
	    })
	  })), _vm._v(" "), _c('div', {
	    staticClass: "team"
	  }, _vm._l((_vm.team), function(person) {
	    return _c('a', {
	      attrs: {
	        "href": person.link,
	        "target": "_blank"
	      }
	    }, [(person.slug) ? _c('img', {
	      attrs: {
	        "src": 'static/images/about/team/' + person.slug + '.jpg',
	        "alt": ""
	      }
	    }) : _vm._e()])
	  })), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "plate"
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./en.yml": 49,
		"./fr.yml": 50
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 75;


/***/ }),
/* 76 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.c1fc0715bdbe3b58d167.js